var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.3392 9.26556L18.1725 18.7106C17.9406 18.9529 17.6619 19.1457 17.3534 19.2774C17.0449 19.4092 16.713 19.4771 16.3775 19.4771C16.0421 19.4771 15.7101 19.4092 15.4016 19.2774C15.0931 19.1457 14.8145 18.9529 14.5825 18.7106L6.00586 9.6189",
    stroke: "#8A8D9C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.83073 8.69733C7.12349 8.69733 6.44521 8.97828 5.94511 9.47838C5.44501 9.97847 5.16406 10.6567 5.16406 11.364V21.364C5.16406 22.0712 5.44501 22.7495 5.94511 23.2496C6.44521 23.7497 7.12349 24.0307 7.83073 24.0307H25.1641C25.8713 24.0307 26.5496 23.7497 27.0497 23.2496C27.5498 22.7495 27.8307 22.0712 27.8307 21.364V8.69733H7.83073Z",
    stroke: "#8A8D9C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.67017bdfcdb15cf6b22672e8d79570eb.svg";
export { ForwardRef as ReactComponent };